import { render, staticRenderFns } from "./detail_member.vue?vue&type=template&id=cf12a7ba&scoped=true&"
import script from "./detail_member.vue?vue&type=script&lang=js&"
export * from "./detail_member.vue?vue&type=script&lang=js&"
import style0 from "./detail_member.vue?vue&type=style&index=0&id=cf12a7ba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf12a7ba",
  null
  
)

export default component.exports